import { getBorderStyle, getLineCap, getLineJoin, ILineCap, ILineJoin } from '@src/framework/editor/src/js/constants';
import { transBorderDashArray } from '@src/framework/editor/src/js/utils';
import { ptToCanvas } from '@src/slide/infrastructure/module/independent/unit';
import { color2HexAndAlpha } from '@src/slide/infrastructure/module/independent/color/transform';

interface StrokeData {
    dashArray: string;
    strokeWidth: number;
    strokeColor: string;
    opacity: number;
    lineCap: ILineCap;
    lineJoin: ILineJoin;
}

class StrokeInfo {
    private opacity = 1;
    private minStrokeWidth?: number;

    public constructor(minStrokeWidth?: number) {
        this.minStrokeWidth = minStrokeWidth;
    }

    public getStrokeData = (model: any, scale?: number): StrokeData => ({
        dashArray: this.getStrokeDashArray(model, scale),
        strokeWidth: this.getStrokeWidth(model, scale),
        strokeColor: this.getStrokeColor(model),
        opacity: this.getStrokeOpacity(),
        lineCap: this.getStrokeLineCap(model),
        lineJoin: this.getStrokeLineJoin(model),
    });

    private getStrokeWidth = (model: any, scale?: number): number => {
        const minStrokeWidth = this.minStrokeWidth ? this.minStrokeWidth : ptToCanvas(0.75);
        const strokeWidth = model?.border?.width ? Math.max(model.border.width, minStrokeWidth) : minStrokeWidth;
        if (scale) {
            return strokeWidth * scale;
        }
        return strokeWidth;
    };

    private getStrokeColor = (model: any): string => {
        let color = model?.border?.color || 'none';
        this.opacity = 1;
        if (color !== 'none') {
            const colorObj = color2HexAndAlpha(color);
            color = `#${colorObj.colorValue}`;
            this.opacity = colorObj.alpha;
        }
        return color;
    };

    /**
     * 在getStrokeColor之后触发
     */
    private getStrokeOpacity = (): number => this.opacity;

    private getStrokeDashArray = (model: any, scale?: number): string => {
        const style = model?.border?.style;
        const lineCap = this.getStrokeLineCap(model);
        let v;
        if (lineCap === 'butt') {
            v = getBorderStyle(style).val2;
        } else {
            v = getBorderStyle(style).val;
        }
        return transBorderDashArray(v, this.getStrokeWidth(model, scale));
    };

    private getStrokeLineCap = (model: any): ILineCap => {
        const cap = model?.border?.linecap;
        return getLineCap(cap).val;
    };

    private getStrokeLineJoin = (model: any): ILineJoin => {
        const isTextOrPlaceholderImage = model.subType === 1 || model.isPlaceholder || model.isImage;
        const join = model?.border?.linejoin;
        return getLineJoin(join, isTextOrPlaceholderImage).val;
    };
}

export default StrokeInfo;
